import { useState } from "react";
import logo from '../media/img/LOGO SIN FONDO.png';

// 👇 Reemplazá esta URL por la de tu foto de fondo (Dropbox con &raw=1 al final).
// Recomendado: imagen apaisada oscura, 2560×1440 px (mínimo 1920×1080), JPG/WebP optimizado.
const BACKGROUND_IMAGE =
  "https://www.dropbox.com/scl/fi/rtvfvpsm97e9110b6stcx/Fondo_Cursos-2.jpg?rlkey=u7zrycq7jvmvumqptt4552kho&st=2q77ouc3&raw=1";

const COURSES = [
  {
    id: 1,
    slug: "workshop-grabacion-edicion-voces",
    title: "Workshop de Grabación y Edición de Voces",
    shortDescription:
      "Un workshop introductorio para quienes quieren empezar a grabar y editar voces con criterio profesional. Grabado y disponible al instante.",
    price: "$75.000 ARS · 60 USD",
    coverImage: "https://www.dropbox.com/scl/fo/ml5sfjfrzdbhfpnrxi5xs/AOQtoOqUd-m58uYsZ1LwO10/Portada%20asincr%C3%B3nico%20taller%20Edici%C3%B3n.jpg?rlkey=gmpodk8djc1m2wirj57oo36x3&st=exojb2zd&raw=1",
    images: [],
    videos: [
      {
        title: "Introducción al workshop",
        vertical: true,
        // 👇 Portada del video (vertical). Reemplazá por tu URL de Dropbox terminada en &raw=1
        poster: "https://www.dropbox.com/scl/fi/ckku5sm36dnokezlnlfui/Portada-video-cursos.jpg?rlkey=cs528am39uzm5m9e4mz81wh9s&st=lbtimopx&raw=1",
        url: "https://www.dropbox.com/scl/fo/ml5sfjfrzdbhfpnrxi5xs/AEE5vZmP5qvYcTohJZ4CDmw/Taller%20asincr%C3%B3nico%20-%20Grabaci%C3%B3n%20y%20edici%C3%B3n%20de%20voces.mp4?rlkey=gmpodk8djc1m2wirj57oo36x3&st=lgtggw5n&raw=1",
      },
    ],
    richContent: [
      {
        type: "text",
        heading: "Descripción general",
        body: "Se trata de un workshop introductorio orientado a personas interesadas en la grabación y edición de voces para locución, doblaje, audiolibros, e-learning, podcasts y contenidos digitales.\n\nEl objetivo es brindar una base sólida sobre los aspectos técnicos y prácticos necesarios para comenzar a grabar y editar voces con calidad profesional.",
      },
      {
        type: "section",
        heading: "Parte teórica",
        subsections: [
          {
            title: "Audio digital",
            items: [
              "Qué es la frecuencia de muestreo (sample rate).",
              "Qué son los bits (bit depth).",
              "Diferencias entre distintas configuraciones de grabación.",
              "Cómo impactan estos parámetros en la calidad del audio.",
            ],
          },
          {
            title: "Micrófonos",
            items: [
              "Micrófonos de condensador.",
              "Micrófonos dinámicos.",
              "Principio de funcionamiento de cada tipo.",
              "Ventajas y desventajas.",
              "Casos de uso recomendados.",
            ],
          },
          {
            title: "Interfaces de audio",
            items: [
              "Función de una interfaz de audio.",
              "Conversión analógico-digital.",
              "Entradas y salidas.",
              "Ganancia y monitoreo.",
            ],
          },
          {
            title: "Monitoreo",
            items: [
              "Uso correcto de auriculares.",
              "Monitores de estudio.",
              "Importancia de escuchar correctamente durante la grabación y edición.",
            ],
          },
          {
            title: "Ecualización",
            items: [
              "Conceptos básicos de EQ.",
              "Cómo identificar frecuencias problemáticas.",
              "Uso práctico en voces.",
            ],
          },
        ],
      },
      {
        type: "section",
        heading: "Parte práctica de grabación",
        subsections: [
          {
            title: null,
            items: [
              "Configuración básica de una sesión.",
              "Preparación del entorno de grabación.",
              "Posicionamiento frente al micrófono.",
              "Control de distancia y nivel.",
              "Manejo de plosivas.",
              "Manejo de respiraciones.",
              "Interpretación y lectura.",
              "Grabación de tomas múltiples.",
              "Organización del material grabado.",
            ],
          },
        ],
      },
      {
        type: "section",
        heading: "Parte práctica de edición",
        intro: "Ejercicios utilizando principalmente REAPER y conceptos aplicables a Pro Tools.",
        subsections: [
          {
            title: null,
            items: [
              "Importación de audio.",
              "Organización de sesiones.",
              "Selección de tomas.",
              "Limpieza de errores.",
              "Eliminación de ruidos no deseados.",
              "Edición de silencios.",
              "Ajuste de respiraciones.",
              "Crossfades.",
              "Consolidación de material.",
              "Exportación de archivos finales.",
            ],
          },
        ],
      },
      {
        type: "emphasis",
        heading: "Énfasis del workshop",
        items: [
          "Desarrollar criterio de escucha.",
          "Trabajar de manera ordenada.",
          "Entender el flujo completo de producción.",
          "Lograr resultados profesionales sin equipamiento extremadamente costoso.",
          "Priorizar la calidad de la grabación desde el origen antes que corregir en postproducción.",
        ],
      },
      {
        type: "contact",
        body: "Estoy disponible para cualquier consulta que surja antes, durante o después del workshop.",
      },
    ],
    googleFormUrl: "https://forms.gle/vNC3fvcpY5RAzfW98",
    duration: "A tu ritmo",
    level: "Inicial",
    tag: "Disponible ahora",
    comingSoon: false,
    modality: "Grabado · Online",
  },
  {
    id: 2,
    slug: "sesion-individual",
    title: "Sesión Individual",
    shortDescription:
      "Una clase personalizada de 60 minutos diseñada para ayudarte a mejorar tu interpretación, Neutro o Rioplatense, grabación, edición y flujo de trabajo de acuerdo con tus necesidades específicas.",
    price: null,
    coverImage: "https://www.dropbox.com/scl/fo/ml5sfjfrzdbhfpnrxi5xs/APANE7g5ZwJ5XFFG84by3CA/Portada%20Sesion%20individual.jpg?rlkey=gmpodk8djc1m2wirj57oo36x3&st=m126budm&raw=1",
    images: [],
    videos: [],
    richContent: [
      {
        type: "text",
        heading: null,
        body: "Durante la sesión podremos trabajar sobre uno de los aspectos técnicos y prácticos que elijas:",
      },
      {
        type: "list",
        items: [
          "Grabación de locuciones, doblajes, audiolibros o e-learning.",
          "Práctica de español neutro.",
          "Práctica de doblaje.",
          "Práctica de audiolibro.",
          "Edición en REAPER o Pro Tools.",
          "Limpieza de audio.",
          "Organización de sesiones.",
          "Resolución de problemas técnicos.",
          "Revisión de trabajos reales.",
          "Consultas sobre equipamiento y flujo de trabajo.",
        ],
      },
      {
        type: "text",
        heading: null,
        body: "La clase se adapta a tu nivel y objetivos, permitiéndote aprovechar el tiempo en los temas que más necesités desarrollar.\n\nIdeal para locutores, actores de voz, narradores de audiolibros, creadores de contenido y cualquier persona que quiera mejorar la calidad de sus producciones de voz con acompañamiento personalizado.\n\nModalidad online · 1 hora de duración. Las veces que gustes.",
      },
    ],
    googleFormUrl: "https://forms.gle/9SMmLviX7hLsZFqM6",
    duration: "1 hora",
    level: "Todos los niveles",
    tag: "Disponible ahora",
    comingSoon: false,
    modality: "Online · En vivo",
  },
  {
    id: 3,
    slug: "curso-doblaje",
    title: "Curso de Doblaje",
    shortDescription:
      "Técnica actoral, sincronización, neutro y flujo de trabajo profesional. Presencial en Buenos Aires u online.",
    price: null,
    coverImage: "https://www.dropbox.com/scl/fo/ml5sfjfrzdbhfpnrxi5xs/ANpypWQrGOz1WpXczxylOUk/Portada%20Neutro%20y%20doblaje.jpg?rlkey=gmpodk8djc1m2wirj57oo36x3&st=nnm4e7ml&raw=1",
    images: [],
    videos: [],
    richContent: [
      {
        type: "emphasis",
        heading: "Fechas y horarios",
        items: [
          "Inicia el sábado 12 de septiembre.",
          "4 clases de 3 horas cada una, los días sábados.",
          "Horario: de 15 a 18 h.",
          "Fechas: sábados 12, 19 y 26 de septiembre, y 3 de octubre.",
          "Cupos limitados: la inscripción se cierra al completarse el cupo.",
        ],
      },
      {
        type: "text",
        heading: null,
        body: "El doblaje es el arte de prestarle la voz a un personaje en otro idioma, respetando la interpretación original, la sincronización y la intención de cada escena. Este curso combina técnica actoral, español neutro y flujo de trabajo profesional para que puedas dar tus primeros pasos —o perfeccionarte— frente al atril.\n\nA lo largo del curso trabajaremos sobre:",
      },
      {
        type: "list",
        items: [
          "Fundamentos del doblaje y su rol en la industria.",
          "Técnica actoral aplicada al doblaje.",
          "Español neutro: pronunciación y dicción.",
          "Sincronización labial (lip sync) y ajuste de tiempos.",
          "Lectura de guion y trabajo en atril.",
          "Interpretación en distintos géneros (animación, live action, documental).",
          "Construcción y diferenciación de personajes.",
          "Manejo de la respiración y la energía vocal.",
          "Trabajo con el director de doblaje.",
          "Flujo de trabajo profesional y grabación en estudio.",
        ],
      },
      {
        type: "text",
        heading: null,
        body: "Además, veremos nociones de grabación y producción para que comprendas cómo se integra tu voz dentro de un proyecto de doblaje, desde la toma hasta la entrega final.\n\nEl objetivo es que adquieras las herramientas interpretativas y técnicas necesarias para enfrentar un atril con seguridad, criterio y una mirada profesional sobre el rol del actor de doblaje.",
      },
    ],
    googleFormUrl: "https://forms.gle/8X693YmkUVf9YXWZ6",
    duration: "4 clases de 3 h",
    level: "Inicial / Intermedio",
    tag: "Inscripción abierta",
    comingSoon: false,
    modality: "Presencial · Online",
    startLabel: "Inicia sáb 12 de septiembre",
    schedule: "Sábados de 15 a 18 h",
    spots: "Cupos limitados",
  },
  {
    id: 4,
    slug: "curso-audiolibros",
    title: "Narración de Audiolibros: De la Lectura a la Interpretación",
    shortDescription:
      "Un curso pensado para actores, locutores y personas que desean iniciarse en la narración de audiolibros o perfeccionar su desempeño frente al micrófono.",
    price: null,
    coverImage: "https://www.dropbox.com/scl/fo/ml5sfjfrzdbhfpnrxi5xs/AGft5fqnqJ_x_7m6MpIA3bs/Portada%20Narracion%20de%20audiolibros.jpg?rlkey=gmpodk8djc1m2wirj57oo36x3&st=ypptf3ol&raw=1",
    images: [],
    videos: [],
    richContent: [
      {
        type: "emphasis",
        heading: "Fechas y horarios",
        items: [
          "Inicia el lunes 7 de septiembre.",
          "4 clases de 3 horas cada una, los días lunes.",
          "Horario: de 19 a 22 h.",
          "Fechas: lunes 7, 14, 21 y 28 de septiembre.",
          "Cupos limitados: la inscripción se cierra al completarse el cupo.",
        ],
      },
      {
        type: "text",
        heading: null,
        body: "Narrar un audiolibro implica mucho más que leer en voz alta. Es interpretar una historia, transmitir emociones, sostener la atención del oyente y dar vida a los personajes respetando la intención del autor.\n\nA lo largo del curso trabajaremos sobre:",
      },
      {
        type: "list",
        items: [
          "Introducción al mundo de los audiolibros.",
          "Análisis y preparación de textos.",
          "Interpretación narrativa.",
          "Ritmo, intención y naturalidad.",
          "Construcción y diferenciación de personajes.",
          "Manejo de diálogos.",
          "Continuidad interpretativa en obras extensas.",
          "Lectura fluida y expresiva.",
          "Técnicas para mantener la atención del oyente.",
          "Uso de la voz en distintos géneros literarios.",
          "Grabación de muestras y material profesional.",
          "Prácticas guiadas con devolución sobre las interpretaciones.",
        ],
      },
      {
        type: "text",
        heading: null,
        body: "Además, veremos conceptos fundamentales sobre grabación y producción para que puedas comprender cómo se desarrolla un proyecto de audiolibro desde la narración hasta su entrega final.\n\nEl objetivo es que desarrolles las herramientas interpretativas necesarias para enfrentarte a una obra de ficción o no ficción con seguridad, criterio y una mirada profesional sobre el rol del narrador.\n\nSi te apasionan las historias y querés aprender a contarlas con tu voz, este curso te brindará las bases para comenzar tu camino en el mundo de los audiolibros.",
      },
    ],
    googleFormUrl: "https://forms.gle/j3YLWWQWJLuxW4Eg6",
    duration: "4 clases de 3 h",
    level: "Inicial / Intermedio",
    tag: "Inscripción abierta",
    comingSoon: false,
    modality: "Presencial · Online",
    startLabel: "Inicia lun 7 de septiembre",
    schedule: "Lunes de 19 a 22 h",
    spots: "Cupos limitados",
  },
];

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .cc-root {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    color: #1a1a1a;
    background-color: #14141a;
    background-image: linear-gradient(rgba(15,15,20,0.80), rgba(15,15,20,0.88)), url('${BACKGROUND_IMAGE}');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100vh;
  }

  /* NAV */
  .cc-nav {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(250,249,247,0.92);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid #e8e4dc;
    padding: 0 clamp(1.25rem, 5vw, 3rem);
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cc-nav-logo {
    font-family: 'DM Serif Display', serif;
    font-size: 1.3rem;
    color: #1a1a1a;
    text-decoration: none;
    letter-spacing: -0.02em;
    cursor: pointer;
    
  }
  .cc-nav-logo span { color: #161853; }

  /* HERO */
  .cc-hero {
    padding: clamp(3rem, 8vw, 6rem) clamp(1.25rem, 5vw, 3rem);
    max-width: 860px;
    margin: 0 auto;
    text-align: center;
  }
  .cc-hero-eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #161853;
    background: #e8e9f8;
    padding: 0.3rem 0.9rem;
    border-radius: 100px;
    margin-bottom: 1.25rem;
  }
  .cc-hero h1 {
    font-family: 'DM Serif Display', serif;
    font-size: clamp(2rem, 5vw, 3.2rem);
    line-height: 1.15;
    letter-spacing: -0.03em;
    color: #f7f6f2;
    margin-bottom: 1.1rem;
  }
  .cc-hero h1 em { font-style: italic; color: #9396dd; }
  .cc-hero p {
    font-size: clamp(0.95rem, 2vw, 1.1rem);
    line-height: 1.7;
    color: #d6d3cc;
    max-width: 580px;
    margin: 0 auto;
  }

  /* CATALOG GRID */
  .cc-catalog-section {
    padding: 0 clamp(1.25rem, 5vw, 3rem) clamp(3rem, 8vw, 5rem);
    max-width: 1200px;
    margin: 0 auto;
  }
  .cc-section-label {
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #d6d3cc;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid rgba(255,255,255,0.16);
  }
  .cc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
    gap: 1.5rem;
  }

  /* CARD */
  .cc-card {
    background: #fff;
    border: 1px solid #e8e4dc;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    display: flex;
    flex-direction: column;
  }
  .cc-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.08);
    border-color: #d4cfc5;
  }
  .cc-card-img-wrap {
    position: relative;
    aspect-ratio: 16/9;
    background: #eef0fb;
    overflow: hidden;
  }
  .cc-card-img-wrap img {
    width: 100%; height: 100%; object-fit: cover;
    transition: transform 0.4s ease;
  }
  .cc-card:hover .cc-card-img-wrap img { transform: scale(1.04); }
  .cc-card-placeholder {
    width: 100%; height: 100%;
    display: flex; align-items: center; justify-content: center;
    background: linear-gradient(135deg, #f4f5fc 0%, #ede8de 100%);
  }
  .cc-card-placeholder svg { opacity: 0.3; }
  .cc-card-tag {
    position: absolute; top: 12px; left: 12px;
    font-size: 0.7rem; font-weight: 500;
    letter-spacing: 0.08em; text-transform: uppercase;
    padding: 0.25rem 0.65rem; border-radius: 100px;
  }
  .cc-tag-hot { background: #161853; color: #fff; }
  .cc-tag-soon { background: #4a3f8a; color: #fff; }
  .cc-tag-available { background: #1a6651; color: #fff; }

  .cc-card-coming-soon { opacity: 1; }
  .cc-coming-soon-banner {
    background: #f3f0fa; border: 1px solid #ccc8e8; border-radius: 10px;
    padding: 0.9rem 1rem; margin-top: 0.4rem;
    display: flex; align-items: flex-start; gap: 0.6rem;
  }
  .cc-coming-soon-banner svg { flex-shrink: 0; margin-top: 2px; }
  .cc-coming-soon-banner p { font-size: 0.82rem; line-height: 1.5; color: #4a3f8a; margin: 0; }
  .cc-coming-soon-banner strong { font-weight: 500; display: block; margin-bottom: 0.1rem; }
  .cc-modality-pill {
    display: inline-flex; align-items: center; gap: 0.3rem;
    background: #eef0fb; color: #777; font-size: 0.74rem;
    padding: 0.2rem 0.6rem; border-radius: 100px;
  }
  .cc-pill-row { display: flex; flex-wrap: wrap; gap: 0.35rem; }
  .cc-pill-start { background: #e8e9f8; color: #161853; font-weight: 500; }
  .cc-pill-spots { background: #f5f3ee; color: #8a7a52; }
  .cc-card-body { padding: 1.25rem; flex: 1; display: flex; flex-direction: column; gap: 0.65rem; }
  .cc-card-meta {
    display: flex; gap: 0.75rem;
    font-size: 0.78rem; color: #888; font-weight: 400;
  }
  .cc-card-meta span { display: flex; align-items: center; gap: 0.25rem; }
  .cc-card h3 {
    font-family: 'DM Serif Display', serif;
    font-size: 1.2rem; line-height: 1.3;
    letter-spacing: -0.02em; color: #111;
  }
  .cc-card p {
    font-size: 0.88rem; line-height: 1.6; color: #666;
    flex: 1;
  }
  .cc-card-cta {
    margin-top: 0.5rem;
    display: inline-flex; align-items: center; gap: 0.4rem;
    font-size: 0.88rem; font-weight: 500; color: #161853;
    background: none; border: none; cursor: pointer; padding: 0;
  }
  .cc-card-cta svg { transition: transform 0.2s ease; }
  .cc-card:hover .cc-card-cta svg { transform: translateX(3px); }

  /* PAYMENT BANNER */
  .cc-payment-banner {
    background: #f5f3ee; border-top: 1px solid #e8e4dc;
    padding: 0.85rem clamp(1.25rem, 5vw, 3rem);
    text-align: center;
    font-size: 0.83rem; color: #666; line-height: 1.5;
  }
  .cc-payment-banner strong { color: #333; }

  /* DETAIL VIEW */
  .cc-detail { animation: cc-fadein 0.25s ease; background: #faf9f7; }
  @keyframes cc-fadein { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

  .cc-detail-hero {
    background: #111;
    padding: clamp(2.5rem, 6vw, 4.5rem) clamp(1.25rem, 5vw, 3rem);
    position: relative;
    overflow: hidden;
  }
  .cc-detail-hero::before {
    content: '';
    position: absolute; inset: 0;
    background: radial-gradient(ellipse at 70% 50%, rgba(22,24,83,0.18) 0%, transparent 60%);
    pointer-events: none;
  }
  .cc-detail-hero-inner { max-width: 1400px; margin: 0 auto; position: relative; }
  .cc-back-btn {
    display: inline-flex; align-items: center; gap: 0.4rem;
    background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.12);
    color: #ccc; font-size: 0.82rem; padding: 0.4rem 0.9rem;
    border-radius: 100px; cursor: pointer; margin-bottom: 1.5rem;
    font-family: 'DM Sans', sans-serif;
    transition: background 0.2s ease;
  }
  .cc-back-btn:hover { background: rgba(255,255,255,0.14); }
  .cc-detail-tag {
    display: inline-block;
    font-size: 0.7rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase;
    padding: 0.3rem 0.8rem; border-radius: 100px; margin-bottom: 1rem;
  }
  .cc-detail-hero h1 {
    font-family: 'DM Serif Display', serif;
    font-size: clamp(1.8rem, 5vw, 3rem);
    letter-spacing: -0.03em; color: #fff; line-height: 1.15;
    margin-bottom: 1rem;
  }
  .cc-detail-hero h1 em { font-style: italic; color: #4c4f8f; }
  .cc-detail-hero p { font-size: 1rem; line-height: 1.7; color: #aaa; max-width: 620px; }
  .cc-detail-meta-row {
    display: flex; flex-wrap: wrap; gap: 1rem;
    margin-top: 1.5rem;
  }
  .cc-detail-meta-pill {
    display: flex; align-items: center; gap: 0.4rem;
    background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);
    color: #bbb; font-size: 0.82rem; padding: 0.4rem 0.9rem; border-radius: 100px;
  }

  /* MAIN ENROLL BAR */
  .cc-enroll-bar {
    background: #fff; border-bottom: 1px solid #e8e4dc;
    padding: 0.9rem clamp(1.25rem, 5vw, 3rem);
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 0.75rem;
    position: sticky; top: 60px; z-index: 90;
  }
  .cc-enroll-bar-text { font-size: 0.9rem; color: #555; }
  .cc-enroll-bar-text strong { color: #111; }
  .cc-enroll-btn {
    background: #161853; color: #fff;
    border: none; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.95rem; font-weight: 500;
    padding: 0.65rem 1.6rem; border-radius: 100px;
    text-decoration: none; display: inline-flex; align-items: center; gap: 0.4rem;
    transition: background 0.2s ease, transform 0.15s ease;
  }
  .cc-enroll-btn:hover { background: #0f113d; transform: scale(1.02); }
  .cc-enroll-btn svg { flex-shrink: 0; }

  /* DETAIL BODY */
  .cc-detail-body {
    max-width: 1400px; margin: 0 auto;
    padding: 2.5rem clamp(1.25rem, 5vw, 3rem);
    display: grid;
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
  @media (min-width: 900px) {
    .cc-detail-body {
      grid-template-columns: 1fr 340px;
    }
    .cc-detail-aside { grid-row: 1 / 4; grid-column: 2; }
  }

  .cc-section-title {
    font-family: 'DM Serif Display', serif;
    font-size: 1.4rem; letter-spacing: -0.02em; color: #111;
    margin-bottom: 1rem;
  }
  .cc-subsection-title {
    font-size: 0.95rem; font-weight: 500; color: #222;
    margin: 1.1rem 0 0.5rem;
  }

  /* RICH CONTENT */
  .cc-rich-block { margin-bottom: 2rem; }
  .cc-rich-block:last-child { margin-bottom: 0; }
  .cc-rich-text { font-size: 0.97rem; line-height: 1.8; color: #444; white-space: pre-line; }
  .cc-rich-list { list-style: none; display: flex; flex-direction: column; gap: 0.4rem; margin-top: 0.5rem; }
  .cc-rich-list li {
    display: flex; align-items: flex-start; gap: 0.65rem;
    font-size: 0.9rem; line-height: 1.55; color: #444;
    padding: 0.6rem 0.9rem;
    background: #faf9f7; border: 1px solid #e8e4dc; border-radius: 9px;
  }
  .cc-rich-list li::before {
    content: '·'; color: #161853; font-size: 1.2rem; line-height: 1; flex-shrink: 0; margin-top: 1px;
  }
  .cc-rich-emphasis {
    background: #faf9f7; border: 1px solid #e8e4dc; border-left: 3px solid #161853;
    border-radius: 0 9px 9px 0; padding: 1rem 1.25rem; margin-top: 0.5rem;
  }
  .cc-rich-emphasis li {
    font-size: 0.9rem; line-height: 1.55; color: #444;
    padding: 0.25rem 0; list-style: none;
    display: flex; align-items: flex-start; gap: 0.5rem;
  }
  .cc-rich-emphasis li::before { content: '·'; color: #161853; font-size: 1.2rem; line-height: 1; flex-shrink: 0; }
  .cc-rich-contact {
    background: #e8e9f8; border-radius: 10px;
    padding: 1rem 1.25rem;
    font-size: 0.9rem; line-height: 1.6; color: #161853;
  }

  /* PRICE */
  .cc-price-tag {
    display: inline-block;
    font-size: 1rem; font-weight: 500; color: #111;
    background: #f4f5fc; border: 1px solid #ddd;
    padding: 0.4rem 1rem; border-radius: 8px;
    margin-bottom: 0.75rem;
  }

  /* VIDEOS */
  .cc-videos { display: flex; flex-wrap: wrap; gap: 1.5rem; align-items: flex-start; }
  .cc-video-vertical { width: 300px; max-width: 100%; }
  .cc-video-vertical .cc-video-item { aspect-ratio: 9 / 16; }
  .cc-video-vertical .cc-video-item video { width: 100%; height: 100%; max-height: none; object-fit: cover; }
  .cc-video-vertical .cc-video-item img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .cc-video-vertical .cc-video-fallback { aspect-ratio: 9 / 16; flex-direction: column; gap: 0.4rem; text-align: center; padding: 1rem; }
  .cc-video-item { border-radius: 12px; overflow: hidden; background: #000; }
  .cc-video-label {
    font-size: 0.8rem; color: #666; margin-bottom: 0.4rem; font-weight: 400;
  }
  .cc-video-item video {
    width: 100%; max-height: 360px; display: block;
    border-radius: 12px;
  }
  .cc-video-fallback {
    display: flex; align-items: center; justify-content: center;
    aspect-ratio: 16/9; background: #eef0fb; border-radius: 12px;
    font-size: 0.85rem; color: #888;
  }

  /* IMAGES */
  .cc-gallery {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
    gap: 0.75rem;
  }
  .cc-gallery-img {
    border-radius: 10px; overflow: hidden;
    background: #eef0fb;
    cursor: zoom-in;
    display: flex; align-items: center; justify-content: center;
  }
  .cc-gallery-img img { width: 100%; height: auto; max-height: 540px; object-fit: contain; display: block; transition: transform 0.3s ease; }
  .cc-gallery-img:hover img { transform: scale(1.05); }

  /* ASIDE CARD */
  .cc-aside-video { margin-bottom: 1.5rem; }
  .cc-detail-aside .cc-video-vertical { width: 100%; }
  .cc-aside-card {
    background: #fff; border: 1px solid #e8e4dc; border-radius: 16px;
    padding: 1.5rem; position: sticky; top: 120px;
  }
  .cc-aside-price-label {
    font-size: 0.78rem; color: #999; letter-spacing: 0.05em; text-transform: uppercase;
    margin-bottom: 0.3rem;
  }
  .cc-aside-card h3 {
    font-family: 'DM Serif Display', serif;
    font-size: 1.25rem; letter-spacing: -0.02em; color: #111; margin-bottom: 0.75rem;
  }
  .cc-aside-card > p { font-size: 0.85rem; line-height: 1.6; color: #666; margin-bottom: 1.25rem; }
  .cc-aside-enroll-btn {
    display: block; width: 100%; text-align: center;
    background: #161853; color: #fff;
    border: none; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.95rem; font-weight: 500;
    padding: 0.8rem 1.5rem; border-radius: 100px;
    text-decoration: none;
    transition: background 0.2s ease, transform 0.15s ease;
    margin-bottom: 0.75rem;
  }
  .cc-aside-enroll-btn:hover { background: #0f113d; transform: scale(1.02); }
  .cc-aside-detail { display: flex; flex-direction: column; gap: 0.5rem; margin-top: 1rem; border-top: 1px solid #e8e4dc; padding-top: 1rem; }
  .cc-aside-row { display: flex; justify-content: space-between; font-size: 0.82rem; }
  .cc-aside-row span:first-child { color: #888; }
  .cc-aside-row span:last-child { font-weight: 500; color: #333; }
  .cc-aside-note { font-size: 0.75rem; color: #aaa; text-align: center; margin-top: 0.75rem; line-height: 1.5; }
  .cc-aside-payment {
    margin-top: 0.85rem; padding-top: 0.85rem; border-top: 1px solid #e8e4dc;
    font-size: 0.75rem; color: #888; line-height: 1.55; text-align: center;
  }

  /* BOTTOM CTA */
  .cc-bottom-cta {
    background: #111; padding: clamp(3rem, 8vw, 5rem) clamp(1.25rem, 5vw, 3rem);
    text-align: center;
  }
  .cc-bottom-cta h2 {
    font-family: 'DM Serif Display', serif;
    font-size: clamp(1.5rem, 4vw, 2.2rem);
    color: #fff; letter-spacing: -0.03em; margin-bottom: 0.75rem;
  }
  .cc-bottom-cta h2 em { font-style: italic; color: #4c4f8f; }
  .cc-bottom-cta p { font-size: 0.95rem; color: #888; margin-bottom: 1.75rem; max-width: 480px; margin-left: auto; margin-right: auto; }

  /* TESTIMONIALS */
  .cc-testimonials {
    padding: clamp(2.5rem, 6vw, 4rem) 0;
    background: #fff;
    border-top: 1px solid #e8e4dc;
    overflow: hidden;
  }
  .cc-testimonials-header {
    padding: 0 clamp(1.25rem, 5vw, 3rem);
    margin-bottom: 2rem;
    text-align: center;
  }
  .cc-testimonials-header h2 {
    font-family: 'DM Serif Display', serif;
    font-size: clamp(1.4rem, 3.5vw, 2rem);
    letter-spacing: -0.03em;
    color: #111;
  }
  .cc-testimonials-header h2 em { font-style: italic; color: #161853; }

  .cc-carousel-track-wrap {
    overflow: hidden;
    position: relative;
  }
  .cc-carousel-track-wrap::before,
  .cc-carousel-track-wrap::after {
    content: '';
    position: absolute;
    top: 0; bottom: 0;
    width: 80px;
    z-index: 2;
    pointer-events: none;
  }
  .cc-carousel-track-wrap::before { left: 0; background: linear-gradient(to right, #fff, transparent); }
  .cc-carousel-track-wrap::after  { right: 0; background: linear-gradient(to left, #fff, transparent); }

  .cc-carousel-track {
    display: flex;
    gap: 1.25rem;
    width: max-content;
    animation: cc-scroll 38s linear infinite;
  }
  .cc-carousel-track:hover { animation-play-state: paused; }
  @keyframes cc-scroll {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  .cc-tcard {
    background: #faf9f7;
    border: 1px solid #e8e4dc;
    border-radius: 14px;
    padding: 1.25rem 1.4rem;
    width: 300px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .cc-tcard-stars {
    display: flex; gap: 3px;
  }
  .cc-tcard-stars svg { color: #161853; }
  .cc-tcard-body {
    font-size: 0.88rem;
    line-height: 1.65;
    color: #444;
    flex: 1;
  }
  .cc-tcard-author {
    font-size: 0.78rem;
    color: #999;
    font-weight: 400;
  }
  @media (max-width: 640px) {
    .cc-enroll-bar { flex-direction: column; align-items: stretch; }
    .cc-enroll-btn { text-align: center; justify-content: center; }
    .cc-aside-card { display: none; }
  }
`;

function tagClass(tag) {
  if (!tag) return "";
  if (tag === "Próximamente") return "cc-tag-soon";
  if (tag === "Disponible ahora") return "cc-tag-available";
  if (tag === "Más vendido") return "cc-tag-hot";
  return "cc-tag-available";
}

function PlaceholderImage() {
  return (
    <div className="cc-card-placeholder">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="10" width="36" height="28" rx="4" stroke="#1a1a1a" strokeWidth="2" fill="none" />
        <circle cx="17" cy="20" r="3" stroke="#1a1a1a" strokeWidth="2" fill="none" />
        <path d="M6 32 L15 22 L22 30 L30 20 L42 34" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

function CourseCard({ course, onView }) {
  return (
    <div
      className={`cc-card${course.comingSoon ? " cc-card-coming-soon" : ""}`}
      onClick={() => onView(course)}
    >
      <div className="cc-card-img-wrap">
        {course.coverImage && !course.coverImage.includes("REPLACE") ? (
          <img src={course.coverImage} alt={course.title} loading="lazy" />
        ) : (
          <PlaceholderImage />
        )}
        {course.tag && (
          <span className={`cc-card-tag ${tagClass(course.tag)}`}>
            {course.tag}
          </span>
        )}
      </div>
      <div className="cc-card-body">
        <div className="cc-card-meta">
          <span>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
            </svg>
            {course.duration}
          </span>
          <span>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
            </svg>
            {course.level}
          </span>
        </div>
        <h3>{course.title}</h3>
        <div className="cc-pill-row">
          {course.modality && (
            <span className="cc-modality-pill">{course.modality}</span>
          )}
          {course.startLabel && (
            <span className="cc-modality-pill cc-pill-start">{course.startLabel}</span>
          )}
          {course.spots && (
            <span className="cc-modality-pill cc-pill-spots">{course.spots}</span>
          )}
        </div>
        <p>{course.shortDescription}</p>
        {course.comingSoon ? (
          <div className="cc-coming-soon-banner">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#4a3f8a" strokeWidth="2" aria-hidden="true">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <p><strong>Próximamente</strong>Sumate a la lista de espera y te avisamos cuando abran las inscripciones.</p>
          </div>
        ) : (
          <button className="cc-card-cta" onClick={(e) => { e.stopPropagation(); onView(course); }}>
            Ver curso
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

function RichContent({ blocks }) {
  return (
    <div>
      {blocks.map((block, i) => {
        if (block.type === "text") {
          return (
            <div key={i} className="cc-rich-block">
              {block.heading && <h3 className="cc-section-title">{block.heading}</h3>}
              <p className="cc-rich-text">{block.body}</p>
            </div>
          );
        }
        if (block.type === "list") {
          return (
            <div key={i} className="cc-rich-block">
              {block.heading && <h3 className="cc-section-title">{block.heading}</h3>}
              <ul className="cc-rich-list">
                {block.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            </div>
          );
        }
        if (block.type === "section") {
          return (
            <div key={i} className="cc-rich-block">
              <h3 className="cc-section-title">{block.heading}</h3>
              {block.intro && <p className="cc-rich-text" style={{ marginBottom: "0.75rem" }}>{block.intro}</p>}
              {block.subsections.map((sub, j) => (
                <div key={j} style={{ marginBottom: "0.75rem" }}>
                  {sub.title && <p className="cc-subsection-title">{sub.title}</p>}
                  <ul className="cc-rich-list">
                    {sub.items.map((item, k) => <li key={k}>{item}</li>)}
                  </ul>
                </div>
              ))}
            </div>
          );
        }
        if (block.type === "emphasis") {
          return (
            <div key={i} className="cc-rich-block">
              {block.heading && <h3 className="cc-section-title">{block.heading}</h3>}
              <div className="cc-rich-emphasis">
                <ul>
                  {block.items.map((item, j) => <li key={j}>{item}</li>)}
                </ul>
              </div>
            </div>
          );
        }
        if (block.type === "contact") {
          return (
            <div key={i} className="cc-rich-block">
              <div className="cc-rich-contact">{block.body}</div>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}

function VideoPlayer({ video }) {
  const isMock = video.url.includes("REPLACE");
  const hasPoster = video.poster && !video.poster.includes("REPLACE");
  const directUrl = video.url.includes("dropbox.com")
    ? video.url.replace("?dl=0", "?raw=1")
    : video.url;
  const wrapClass = video.vertical ? "cc-video-vertical" : "";

  if (isMock) {
    return (
      <div className={wrapClass}>
        <div className="cc-video-label">{video.title}</div>
        {hasPoster ? (
          <div className="cc-video-item">
            <img src={video.poster} alt={video.title} />
          </div>
        ) : (
          <div className="cc-video-fallback">
            <span>Video {video.vertical ? "vertical " : ""}· {video.title}</span>
            <span>Vinculá tu URL y portada de Dropbox</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={wrapClass}>
      <div className="cc-video-label">{video.title}</div>
      <div className="cc-video-item">
        <video controls preload="metadata" poster={hasPoster ? video.poster : undefined}>
          <source src={directUrl} />
          Tu navegador no soporta reproducción de video.
        </video>
      </div>
    </div>
  );
}

function CourseDetail({ course, onBack }) {
  const realImages = course.images.filter((img) => !img.includes("REPLACE"));
  const realCover = course.coverImage && !course.coverImage.includes("REPLACE");
  const verticalVideos = course.videos.filter((v) => v.vertical);
  const inlineVideos = course.videos.filter((v) => !v.vertical);

  return (
    <div className="cc-detail">
      <div className="cc-detail-hero">
        <div className="cc-detail-hero-inner">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "1rem", flexWrap: "wrap", marginBottom: "1.25rem" }}>
            <button className="cc-back-btn" style={{ marginBottom: 0 }} onClick={onBack}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              Todos los cursos
            </button>
            {course.tag && (
              <div className={`cc-detail-tag ${tagClass(course.tag)}`} style={{ marginBottom: 0 }}>
                {course.tag}
              </div>
            )}
          </div>
          <h1>{course.title}</h1>
          <p>{course.shortDescription}</p>
          <div className="cc-detail-meta-row">
            <div className="cc-detail-meta-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
              </svg>
              {course.duration}
            </div>
            <div className="cc-detail-meta-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
              </svg>
              {course.level}
            </div>
            {course.modality && (
              <div className="cc-detail-meta-pill">{course.modality}</div>
            )}
            {course.schedule && (
              <div className="cc-detail-meta-pill">{course.schedule}</div>
            )}
            {course.spots && (
              <div className="cc-detail-meta-pill">{course.spots}</div>
            )}
          </div>
        </div>
      </div>

      <div className="cc-enroll-bar">
        <div className="cc-enroll-bar-text">
          <strong>{course.title}</strong>
          {course.price && <span style={{ color: "#161853", marginLeft: "0.75rem", fontWeight: 500 }}>{course.price}</span>}
        </div>
        {course.comingSoon ? (
          <a href={course.googleFormUrl} target="_blank" rel="noopener noreferrer" className="cc-enroll-btn" style={{ background: "#4a3f8a" }}>
            Sumarme
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        ) : (
          <a href={course.googleFormUrl} target="_blank" rel="noopener noreferrer" className="cc-enroll-btn">
            Inscribirme
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        )}
      </div>

      <div className="cc-detail-body">
        <div>
          {inlineVideos.length > 0 && (
            <div className="cc-videos" style={{ marginBottom: "2rem" }}>
              {inlineVideos.map((v, i) => (
                <VideoPlayer key={i} video={v} />
              ))}
            </div>
          )}

          {(realImages.length > 0 || realCover) && (
            <div className="cc-gallery" style={{ marginBottom: "2rem" }}>
              {realCover && (
                <div className="cc-gallery-img">
                  <img src={course.coverImage} alt={course.title} loading="lazy" />
                </div>
              )}
              {realImages.map((img, i) => (
                <div key={i} className="cc-gallery-img">
                  <img src={img} alt={`${course.title} ${i + 1}`} loading="lazy" />
                </div>
              ))}
            </div>
          )}

          <RichContent blocks={course.richContent} />
        </div>

        <aside className="cc-detail-aside">
          {verticalVideos.length > 0 && (
            <div className="cc-aside-video">
              {verticalVideos.map((v, i) => (
                <VideoPlayer key={i} video={v} />
              ))}
            </div>
          )}
          <div className="cc-aside-card">
            <div className="cc-aside-price-label">
              {course.comingSoon ? "Lista de espera" : "Inscripción"}
            </div>
            <h3>{course.title}</h3>
            {course.price && (
              <div className="cc-price-tag">{course.price}</div>
            )}
            <p>
              {course.comingSoon
                ? "Dejá tu nombre y te avisamos cuando se confirmen las fechas."
                : "Completá el formulario y te contactaremos para coordinar el acceso y el método de pago."}
            </p>
            <a
              href={course.googleFormUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cc-aside-enroll-btn"
              style={course.comingSoon ? { background: "#4a3f8a" } : {}}
            >
              {course.comingSoon ? "Sumarme" : "Inscribirme ahora"}
            </a>
            <div className="cc-aside-detail">
              <div className="cc-aside-row">
                <span>Duración</span>
                <span>{course.duration}</span>
              </div>
              <div className="cc-aside-row">
                <span>Nivel</span>
                <span>{course.level}</span>
              </div>
              {course.modality && (
                <div className="cc-aside-row">
                  <span>Modalidad</span>
                  <span>{course.modality}</span>
                </div>
              )}
              {course.startLabel && (
                <div className="cc-aside-row">
                  <span>Inicio</span>
                  <span>{course.startLabel.replace("Inicia ", "")}</span>
                </div>
              )}
              {course.schedule && (
                <div className="cc-aside-row">
                  <span>Cursada</span>
                  <span>{course.schedule}</span>
                </div>
              )}
              {course.spots && (
                <div className="cc-aside-row">
                  <span>Cupos</span>
                  <span>Limitados</span>
                </div>
              )}
            </div>
            <div className="cc-aside-payment">
              Podés pagar con <strong>transferencia bancaria</strong> o <strong>tarjeta de crédito en cuotas</strong>.
            </div>
          </div>
        </aside>
      </div>

      <div className="cc-bottom-cta">
        {course.comingSoon ? (
          <>
            <h2>¿Querés ser de los <em>primeros en anotarte</em>?</h2>
            <p>Dejá tus datos y te avisamos cuando se confirmen las fechas.</p>
            <a href={course.googleFormUrl} target="_blank" rel="noopener noreferrer" className="cc-enroll-btn" style={{ background: "#4a3f8a" }}>
              Sumarme
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </>
        ) : (
          <>
            <h2>¿Listo para <em>empezar</em>?</h2>
            <p>Completá el formulario y te contactamos para darte acceso.</p>
            <a href={course.googleFormUrl} target="_blank" rel="noopener noreferrer" className="cc-enroll-btn">
              Inscribirme
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </>
        )}
      </div>
    </div>
  );
}

const TESTIMONIALS = [
  { text: "Fue una tremenda experiencia y me encantaría más de lo mismo, en el mismo lugar, y ojalá, con los mismos compañeros. Espero ansioso poder regresar. ¡Los quiero!" },
  { text: "Me encantó la paciencia, el profesionalismo y la humildad de ustedes. Gracias por todo y les deseo el mejor de los éxitos... abrazo mágico ✴️" },
  { text: "El hecho de poder enviar consultas y que sean respondidas es muy útil para evacuar dudas." },
  { text: "La clase me pareció buena. Eze nos enseñó todo lo que necesitábamos para poder hacer doblaje." },
  { text: "¡Super claro Eze! Me encantó tu taller. Espero poder aplicar todo lo que enseñaste. ¡Muchas gracias!" },
  { text: "Sirvió mucho para recordar conocimientos, aprender nuevos datos y obtener nuevas herramientas. Lo más valioso fueron los comentarios sobre cómo se organizan las cosas a nivel profesional en la actualidad. ¡Fue una gran inversión!" },
  { text: "Excelente clase, muy bueno todo." },
  { text: "Me pareció súper interesante. Muy didáctico y se abarcó gran cantidad de temas. Muy claros los conceptos y los ejemplos. Bien específico en grabación y edición de voz. Muy generoso en el tiempo, conocimientos y dedicación. ¡Un mil gracias!" },
  { text: "Me gustaría en algún momento poder ejercerlo en el futuro." },
  { text: "Faltó fotito final! jaja. Muy buen taller." },
];

function StarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="#161853" aria-hidden="true">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );
}

function Testimonials() {
  const doubled = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section className="cc-testimonials">
      <div className="cc-testimonials-header">
        <h2>¿Qué dicen nuestros <em>estudiantes</em>?</h2>
      </div>
      <div className="cc-carousel-track-wrap">
        <div className="cc-carousel-track">
          {doubled.map((t, i) => (
            <div key={i} className="cc-tcard">
              <div className="cc-tcard-stars">
                {[...Array(5)].map((_, s) => <StarIcon key={s} />)}
              </div>
              <p className="cc-tcard-body">"{t.text}"</p>
              <span className="cc-tcard-author">Estudiante · Etervoz</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function CourseCatalog() {
  const [activeCourse, setActiveCourse] = useState(null);

  const handleView = (course) => {
    setActiveCourse(course);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    setActiveCourse(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>{styles}</style>
      <div className="cc-root">
        <nav className="cc-nav">
          <span className="cc-nav-logo" onClick={handleBack}>
            <img src={logo} alt='logo' style={{ width: "50px" }}/><span>Etervoz</span>
          </span>
          {activeCourse && (
            <button
              className="cc-back-btn"
              style={{ margin: 0 }}
              onClick={handleBack}
            >
              ← Cursos
            </button>
          )}
        </nav>

        {activeCourse ? (
          <CourseDetail course={activeCourse} onBack={handleBack} />
        ) : (
          <>
            <section className="cc-hero">
              <span className="cc-hero-eyebrow">Formación profesional</span>
              <h1>
                Cursos y talleres <em>de voz</em>
              </h1>
              <p>
                Formación práctica en grabación, locución, doblaje y audiolibros.
              </p>
            </section>

            <section className="cc-catalog-section">
              <div className="cc-section-label">
                {COURSES.length} cursos disponibles
              </div>
              <div className="cc-grid">
                {COURSES.map((course) => (
                  <CourseCard key={course.id} course={course} onView={handleView} />
                ))}
              </div>
            </section>

            <Testimonials />

            <div className="cc-payment-banner">
              Todos los talleres se pueden abonar con <strong>transferencia bancaria</strong> o <strong>tarjeta de crédito en cuotas</strong>.
            </div>

            <div className="cc-bottom-cta">
              <h2>
                ¿Tenés alguna <em>duda antes de inscribirte</em>?
              </h2>
              <p>Entrá a cada curso para ver el detalle completo, o envianos un correo a info@etervoz.com</p>
            </div>
          </>
        )}
      </div>
    </>
  );
}
